import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState } from 'react';
import { useWebUIConfigOptions } from './ThemeProvider2.js';
import { Drawer } from './Drawer3.js';

const drawerContext = createContext({
    position: 'end',
    showCloseIcon: true,
    onClose: () => undefined,
    preventAutoClose: false,
    title: '',
    isShown: false,
    showDrawer: () => undefined,
    closeDrawer: () => undefined,
});
const DrawerProvider = ({ children }) => {
    const [contextValues, setContextValues] = useState({
        position: 'end',
        showCloseIcon: true,
        onClose: () => undefined,
        preventAutoClose: false,
        title: '',
        isShown: false,
        closeDrawer: () => undefined,
    });
    return (jsxs(drawerContext.Provider, { value: Object.assign(Object.assign({}, contextValues), { showDrawer: (newValues) => {
                setContextValues(Object.assign(Object.assign(Object.assign({}, contextValues), newValues), { isShown: true }));
            }, closeDrawer: () => {
                setContextValues(Object.assign(Object.assign({}, contextValues), { isShown: false }));
            } }), children: [children, jsx(Drawer, Object.assign({}, contextValues, { closeDrawer: () => {
                    setContextValues(Object.assign(Object.assign({}, contextValues), { isShown: false }));
                } }))] }));
};
const useDrawer = () => {
    var _a;
    const { showDrawer, closeDrawer } = useContext(drawerContext);
    const { drawer } = useWebUIConfigOptions();
    const defaultProps = __rest((_a = drawer === null || drawer === void 0 ? void 0 : drawer.drawerDefaults) !== null && _a !== void 0 ? _a : {}, []);
    const onShowDrawer = (props) => {
        if (props) {
            showDrawer(Object.assign(Object.assign({}, defaultProps), props));
        }
    };
    return {
        showDrawer: (props) => {
            onShowDrawer(props);
        },
        closeDrawer: closeDrawer,
    };
};

export { DrawerProvider, useDrawer };
